import { theme } from '@noths/polaris-client-ribbons-base';
import { stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var dropDown = /*#__PURE__*/css(["margin:", ";"], stack(spacing.xl));